import { relationships } from "@rocicorp/zero";
import { file } from "./file";
import { ticketFiles } from "./ticket-files";

export const ticketFilesRelationships = relationships(ticketFiles, ({ one }) => ({
	file: one({
		sourceField: ["fileId"],
		destField: ["id"],
		destSchema: file,
	}),
}));
